<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">{{listName}} </span>
      <button @click="openModalList()" style="float:right;width:186px;">Editar Lista</button>
    </div>
    <div class="lineBox" style="margin-top:10px; min-height: 75px; min-width:1010px;">
      <div style="padding:10px; ">
        <table class="table" cellpadding="0" cellspacing="0" style="min-width:820px">
          <thead>
          <tr>
            <td style="text-align:left;cursor: pointer;" @click="sortByProductAttr('name')">Nome</td>
            <td>Ordem dos Produtos</td>
            <td>Remover da Lista</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(p, idx ) in list.products" v-bind:key="idx">
            <td>{{p.name}}</td>
            <td style="text-align:right;">
              <OpaContentEditable type="number" decimal="0" v-model="p.listOrder" @click="(e) => updateProductOrder(p, e)"/>
            </td>
            <td style="text-align:center;">
              <div style="display:inline-flex;">
                <div @click="removeProductFromList(p)"><OpaIcon name="remove"  alt="Excluir" color="red" style="cursor:pointer;margin:6px;"/></div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <OpaModal v-model="showModalList" width="800" height="700" header="Lista de Produtos">
      <div style="height:550px;overflow:auto; padding:20px;">
        <input type="text" class="inputText inputTag" placeholder="Nome" v-model="list.name"/>
        <br/><br/>
        <input type="number" class="inputText inputTag" placeholder="Ordem" v-model="list.order"/>
        <br/><br/>
        <select v-model="list.type" class="inputText" style="width: 279px">
          <option value="" disabled selected>Selecione o tipo de exibição</option>
          <option :value="this.CUSTOM_LIST">Lista</option>
          <option :value="this.CUSTOM_CARD">Card</option>
        </select>
        <span v-if="list.type === this.CUSTOM_LIST"><br/><br/>O tipo de exibição <b>"Lista"</b> foi selecionado, os produtos irão aparecer agrupados em formato de lista na página "home".</span>
        <span v-else-if="list.type === this.CUSTOM_CARD"><br/><br/>O tipo de exibição <b>"Card"</b> foi selecionado, os produtos irão aparecer agrupados em formato de card na página "home" somente na versão web. <b>Campo imagem é obrigatório.</b></span>
        <br/><br/>
        <tr>
          <td>Adicionar Imagem</td>
          <td style="height:300px;">
            <OpaDragImage @uploadImage="(image) => updateImageList(image)"/>
          </td>
          <td>
            <img v-if="list.photo" :src="getImage(list) " style="max-width:400px;">
          </td>
        </tr>
        <template>
          <MultiSelect  v-model="listProducts"
                        track-by="id"
                        placeholder="Adicionar produtos"
                        selectLabel=""
                        open-direction="bottom"
                        :options="allProducts"
                        :multiple="true"
                        :searchable="true"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="false"
                        :show-no-results="true"
                        :hide-selected="true"
                        :loading="isLoading"
                        @search-change="filterSearch"
                        @select="addProductToList" style="line-height: 29px;">
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="custom__tag" style="border: solid 1px #AAAAAA;border-radius: 10px;padding: 0px 10px;margin-right: 5px;display:inline-block;margin-bottom: 3px;" ><span>{{ option.name }}</span>
                <span class="custom__remove" style="zoom: 0.9;position: relative;top: -1px;" @click="remove(option)">❌</span>
              </span>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc"><span class="option__title">{{ props.option.name }}</span><span class="option__small"> ({{ props.option.ean }}) </span></div>
            </template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="listProducts.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
            </template><span slot="noResult">Nenhum resultado encontrado no filtro.</span>
          </MultiSelect>
        </template>
      </div>

      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="addProducts()">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="closeModalList()">Cancelar</button>
      </div>
    </OpaModal>

  </div>

</template>

<script>

  import { mapGetters } from 'vuex'
  import formaters from '@/mixins/formater'
  import OpaIcon from '@/components/OpaIcon.vue'
  import OpaContentEditable from '@/components/OpaContentEditable.vue'
  import OpaModal from '@/components/OpaModal.vue'
  import { EventBus } from '@/utils/event-bus'
  import axios from 'axios'
  import ProductsConn from '@/connection/Product'
  import searchScore from '@/mixins/searchScore'
  import MultiSelect from 'vue-multiselect'
  import _ from 'lodash'
  import OpaDragImage from '@/components/OpaDragImage.vue'

  export default {

    name: 'List',

    data () {
      return {
        list: {
          name: '',
          order: null,
          type: '',
          photo: null
        },
        listName : '',
        allProducts: {},
        listProducts : [],
        listProductsIds : [],
        showModalList: false,
        isLoading: true,
        CUSTOM_CARD: 'CUSTOM_CARD',
        CUSTOM_LIST: 'CUSTOM_LIST'
      }
    },

    components: {OpaIcon, OpaContentEditable, OpaModal, MultiSelect, OpaDragImage},

    mixins: [formaters, searchScore],

    computed: {

      ...mapGetters([ 'getProductApi', 'getOpaApi' ]),

    },

    async created () {
      await this.getProductsIndex()
      await this.getProductsByListId(this.$route.params.listId)
      this.isLoading = false
    },

    methods: {

      ...mapGetters([ 'getCompany', 'getProductsIndexApi' ]),

      async getProductsIndex () {
        this.loading = true
        let r = await ProductsConn.getProductsIndex()
        if (!r.error) {
          this.allProductsFull = r.map((product) => {
            product.text = product.name
            product.value = product.id
            return product
          })
          this.allProducts = _.clone(this.allProductsFull)
          console.log("product list size:",this.allProducts.length)
        } else {
          console.log('error', r)
        }
      },

      /**
       * @param listId - Id da lista em que se deseja buscar a lista de itens cadastrados.
       */
      async getProductsByListId (listId) {
        this.loading = true
        let r = await ProductsConn.getProductsByListId(listId)
        if (!r.error) {
          this.list = r
          this.listName = r.name
          this.fillProductsData()
        } else {
          console.log('error', r)
        }
      },

      fillProductsData () {
        //Fill product list with all product information
        let vm = this
        this.listProductsIds = this.list.products.map (product => product.id)
        this.listProducts = []
        this.list.products.forEach(listObj => {
          //Get products with order inside list
          let found = vm.allProducts.find(p => p.id === listObj.id)
          if (found){
            let product = found
            product.listOrder = listObj.order
            vm.listProducts.push(product)
          }

        })
        this.list.products = this.listProducts.sort((a, b) => {
          return a.listOrder - b.listOrder
        })
      },

      getImage(list) {
        console.log(list)
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/list/' + list.photo
      },

      updateImageList(file) {
        console.log('NEW FILE => ', file)
        let vm = this
        let bodyFormData = new FormData()
        bodyFormData.append('file', file)
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi + '/files/company/' + this.getCompany().companyId + '/path/list',
          data: bodyFormData,
          config: {headers: {'Content-Type': 'form-data'}}
        })
          .then(function (response) {
            console.log('banner file', response.data)
            vm.list.photo = response.data.file_name
            EventBus.$emit('showLoading', false)
          })
          .catch(function (response) {
            console.log(response)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
          })
      },

      updateProductOrder(product, newOrder) {
        let vm = this
        let foundIndex = vm.list.products.findIndex(p => p.id === product.id)
        vm.list.products[foundIndex].listOrder = newOrder
        this.updateList()
      },

      removeProductFromList(product) {
        let vm = this
        vm.list.products = vm.list.products.filter (p => p.id !== product.id)
        //TODO rollback if fails?
        this.updateList()
      },

      addProducts() {
        this.list.products = this.listProducts
        if (!this.list.name) {
          EventBus.$emit('showAlert', 'error', 'Erro ao salvar lista, preencha campo "nome"')
          return
        } else if (!this.list.type) {
          EventBus.$emit('showAlert', 'error', 'Erro ao salvar lista, selecione um tipo para lista')
          return
        } else if (!this.list.products.length) {
          EventBus.$emit('showAlert', 'error', 'Erro ao salvar lista, adicione ao menos um produto')
          return
        } else if (this.list.type === this.CUSTOM_CARD && !this.list.photo) {
          EventBus.$emit('showAlert', 'error', 'Erro ao salvar lista, adicione foto')
          return
        }
        this.updateList()
      },

      updateList() {
        EventBus.$emit('showLoading', true)
        let vm = this
        axios.put(this.getProductApi + '/product-list',
                {
                  id: this.list.id,
                  name: this.list.name,
                  order: this.list.order ? parseInt(this.list.order, 10) : 0,
                  products: this.list.products.map(product => {
                    return {
                      id: product.id,
                      order: product.listOrder
                    }
                  }),
                  type: this.list.type,
                  photo: this.list.photo,
                }
                )
                .then((response) => {
                  vm.list = response.data
                  vm.listName = response.data.name
                  vm.fillProductsData ()
                  EventBus.$emit('showLoading', false)
                  EventBus.$emit('showAlert', 'success', 'Lista atualizada com sucesso')
                  this.closeModalList()
                })
                .catch((e) => {
                  console.log(e)
                  EventBus.$emit('showLoading', false)
                  EventBus.$emit('showAlert', 'error', 'Erro ao salvar lista')
                })
      },

      openModalList() {
        this.showModalList = true
      },

      closeModalList() {
        this.listProducts = this.list.products
        this.showModalList = false
      },

      addProductToList (selectedItem) {
        let vm = this
        //Set order of new element as bigger
        selectedItem.listOrder  = Math.max.apply(Math, vm.listProducts.filter(item => item.listOrder).map(function(o) { return o.listOrder; })) + 1
      },

      filterSearch(searchQuery) {
        if (searchQuery.length < 2) {
          this.allProducts = this.allProductsFull
          return;
        }
        this.allProducts = this.filterIndexedProduct(this.allProductsFull, searchQuery, -1, true, true).productList
      },

    }

  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> 
<style lang="scss" scoped>

  /* Esconde o input */
  input[type='file'] {
    display: none;


  }
</style>
